import React, {useCallback, useState} from 'react'
import app from './App.module.scss'
import Main from '../../pages/Main/Main'
import Header  from '../Header/Header'
import Footer  from '../Footer/Footer'
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy'
import ModalImage from '../ModalImage/ModalImage'
import ModalForm  from '../ModalForm/ModalForm'
import Modal from '../../components/Modal/Modal'
import Career from '../Career/Career'


import UpButton from '../UpButton/UpButton'

function App() {

  const [isPopupPrivacyPolicyOpen, setIsPopupPrivacyPolicyOpen] = useState(false)
  const [isPopupImageOpen, setIsPopupImageOpen] = useState(false)
  const [isArr, setIsArr] = useState(null)
  const [isPopupFormOpen, setIsPopupFormOpen] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isRus, setIsRus] = useState(true)
  const [isCareer, setIsCareer] = useState(false)

  const vh = window.innerHeight / 100;
  document.documentElement.style.setProperty('--vh', `${vh}px`);


  const handlePrivacyPolicyClose = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(false)
  }, []);

  const handlePrivacyPolicyOpen = useCallback(() => {
    setIsPopupPrivacyPolicyOpen(true)
  }, [])

  const handleImageClose = useCallback(() => {
    setIsPopupImageOpen(false)
  }, []);

  const handleImageOpen = useCallback((arr) => {
      setIsPopupImageOpen(true)
      setIsArr(arr)
  }, [])

  const handleFormOpen = useCallback(() => {
    setIsPopupFormOpen(true)
  }, []);

  const handleFormClose = useCallback(() => {
    setIsPopupFormOpen(false)
  }, []);

  const handleOpen = useCallback(() => {
    setIsPopupOpen(true)
  }, []);

  const handleClose = useCallback(() => {
    setIsPopupOpen(false)
  }, []);

  const handleLanguage = useCallback(() => {
          setIsRus(!isRus)
  }, [isRus]);

  const handleCareerOpen = useCallback(() => {
    setIsCareer(true)
  }, []);

  const handleCareerClose = useCallback(() => {
    setIsCareer(false)
  }, []);



  return (
    <div className={app.page}>
      <Header
        isRus={isRus}
        enable={handleLanguage}
      />
      <Main
        isImageOpen={handleImageOpen}
        isOpen={handleFormOpen}
        isRus={isRus}
        isCareerOpen={handleCareerOpen}
      />
      <Footer
        isOpen={handlePrivacyPolicyOpen}
        isRus={isRus}
      />
      <UpButton/>
      {isPopupPrivacyPolicyOpen && 
      <PrivacyPolicy
        onClose={handlePrivacyPolicyClose}
      />}
      {isCareer && 
      <Career
        onClose={handleCareerClose}
        isRus={isRus}
      />}
      {isPopupImageOpen && 
      <ModalImage
        onClose={handleImageClose}
        arr={isArr}
      />}
      {isPopupFormOpen && <ModalForm
        onClose={handleFormClose}
        popupOpen={handleOpen}
        isPrivacyPolicyOpenOpen={handlePrivacyPolicyOpen}
        isRus={isRus}
      ></ModalForm>}
      {isPopupOpen && 
      <Modal
        onClose={handleClose}
        isRus={isRus}
      />}
    </div>
  );
}

export default App;
